/* ==========================================================================
   live-match-collection.js  (collection pages only; loaded by
   sections/main-collection-banner.liquid)

   1. Filter groups (Boost App Lib V3, .boost-sd__filter-option):
      - every group starts CLOSED;
      - only ONE group is open at a time; the open group STAYS open through value selections and
        re-renders until the user closes it. Open groups are stored in
        sessionStorage per collection path and re-applied from a
        MutationObserver callback (a microtask, so it runs before paint and
        does not flicker);
      - per-group selected count  -> heading gets data-lmc-count  ("COLOUR (3)");
      - per-group clear X         -> .lmc-opt-clear, deselects that group's values.
      Theme-owned open/close: clicks on a group title are handled here and not
      passed to Boost, so Boost's own collapse state never changes.
   2. Sort: "Remove sorting preference" row, and the dropdown/panel closes
      as soon as a choice is made.
   3. Filter toggle +/- kept in sync with the panel (body.filter-opened) after
      every Boost re-render (re-rendered toolbars lose the .active class).
   4. <=1024px: the "Filters" button opens Boost's own mobile panel, because Boost
      only fills the filter values into that panel on those widths (see section 4).
   (Mobile default grid of 2 per row is set by an inline script in
    sections/main-collection-banner.liquid so it runs before global.js.)
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------------------- 1. filter groups ---------------------------- */
  var OPT = '.boost-sd__filter-option';
  var TITLE = '.boost-sd__filter-option-title';
  var HEADING = '.boost-sd__filter-option-heading';
  var SELECTED = '.boost-sd__filter-option-item-button--selected, .boost-sd__filter-option-item-button[aria-checked="true"]';
  var STORE_KEY = 'lmc-open-filters:' + location.pathname.replace(/\/+$/, '');

  function loadOpen() {
    try { return JSON.parse(sessionStorage.getItem(STORE_KEY) || '[]'); } catch (e) { return []; }
  }
  function saveOpen(list) {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify(list)); } catch (e) {}
  }
  // Only one group open at a time (Robin 22 Oct): keep at most the last opened group.
  var openKeys = loadOpen().slice(-1);

  function keyOf(opt) {
    var h = opt.querySelector(HEADING) || opt.querySelector(TITLE);
    // ignore any "(n)" count Boost may print, so the key is stable across selections
    return h ? h.textContent.replace(/\(\s*\d+\s*\)/g, '').replace(/\s+/g, ' ').trim().toUpperCase() : '';
  }

  var applying = false;
  function apply() {
    if (applying) return;
    applying = true;
    try {
      // 3. toggle sign: "-" while the panel is open, "+" when closed
      var panelOpen = document.body.classList.contains('filter-opened');
      var boxes = document.querySelectorAll('.coll-bs-filter-box');
      for (var b = 0; b < boxes.length; b++) {
        if (boxes[b].classList.contains('active') !== panelOpen) boxes[b].classList.toggle('active', panelOpen);
      }

      var opts = document.querySelectorAll(OPT);
      for (var i = 0; i < opts.length; i++) {
        var opt = opts[i];
        var key = keyOf(opt);
        if (!key) continue;

        // open / closed (only touch the DOM when the state differs, so the observer settles)
        var shouldOpen = openKeys.indexOf(key) !== -1;
        if (opt.classList.contains('lmc-open') !== shouldOpen) opt.classList.toggle('lmc-open', shouldOpen);
        var t = opt.querySelector(TITLE);
        if (t && t.getAttribute('aria-expanded') !== String(shouldOpen)) t.setAttribute('aria-expanded', String(shouldOpen));

        // selected count
        var n = opt.querySelectorAll(SELECTED).length;
        var h = opt.querySelector(HEADING);
        if (h) {
          if (n > 0 && h.getAttribute('data-lmc-count') !== String(n)) h.setAttribute('data-lmc-count', String(n));
          if (n === 0 && h.hasAttribute('data-lmc-count')) h.removeAttribute('data-lmc-count');
        }
        if (opt.classList.contains('lmc-has-selected') !== (n > 0)) opt.classList.toggle('lmc-has-selected', n > 0);

        // clear X
        if (!opt.querySelector(':scope > .lmc-opt-clear')) {
          var x = document.createElement('span');
          x.className = 'lmc-opt-clear';
          x.setAttribute('role', 'button');
          x.setAttribute('tabindex', '0');
          x.setAttribute('aria-label', 'Clear ' + key.toLowerCase());
          opt.appendChild(x);
        }
      }
    } finally {
      applying = false;
    }
  }

  function findOpt(key) {
    var opts = document.querySelectorAll(OPT);
    for (var i = 0; i < opts.length; i++) if (keyOf(opts[i]) === key) return opts[i];
    return null;
  }

  // Deselect a group's values one by one. Boost re-renders after each click, so the
  // next selected button is looked up again each time.
  function clearGroup(key, guard) {
    guard = guard || 0;
    if (guard > 40) return;
    var opt = findOpt(key);
    var sel = opt && opt.querySelector(SELECTED);
    if (!sel) return;
    sel.click();
    setTimeout(function () { clearGroup(key, guard + 1); }, 150);
  }

  // Capture phase on document: runs before Boost's (React) handlers.
  document.addEventListener('click', function (e) {
    var x = e.target.closest && e.target.closest('.lmc-opt-clear');
    if (x) {
      e.preventDefault();
      e.stopPropagation();
      var o = x.closest(OPT);
      if (o) clearGroup(keyOf(o));
      return;
    }
    var title = e.target.closest && e.target.closest(TITLE);
    if (title) {
      var opt = title.closest(OPT);
      if (!opt) return;
      e.preventDefault();
      e.stopPropagation(); // Boost keeps its own collapse state unchanged; the theme owns open/close
      var key = keyOf(opt);
      var idx = openKeys.indexOf(key);
      openKeys = idx === -1 ? [key] : []; // opening a group closes the others
      saveOpen(openKeys);
      apply();
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('lmc-opt-clear')) {
      e.preventDefault();
      e.target.click();
    }
  }, true);

  var mo = new MutationObserver(function () { apply(); });
  function start() {
    apply();
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-checked'] });
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);

  /* --------------------------------- 2. sort -------------------------------- */
  document.addEventListener('click', function (e) {
    var reset = e.target.closest && e.target.closest('[data-lmc-sort-reset]');
    var choice = e.target.closest && e.target.closest('.bc-sf-filter-filter-dropdown a');
    if (!reset && !choice) return;
    // close the desktop dropdown / mobile panel immediately
    document.querySelectorAll('.coll-bs-sort_by-box.active').forEach(function (b) { b.classList.remove('active'); });
    document.body.classList.remove('sorting-open');
    if (reset) {
      e.preventDefault();
      e.stopPropagation(); // global.js would otherwise set sort=undefined
      var url = new URL(window.location.href);
      url.searchParams.delete('sort');
      url.searchParams.delete('sort_by');
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  }, true);

  /* ------------------- 4. mobile / tablet filter panel (<=1024px) ------------------
     Boost fills the filter values only into its own mobile panel (#boost-sd_filter-tree-mobile)
     up to 1024px; the left-column drawer stays empty there. So on those widths the theme's
     "Filters" button opens Boost's panel (via Boost's hidden toggle button) instead of the old
     drawer. Boost then owns the panel: close X, "Show result (n)", body scroll lock.
     Styling: PART C of assets/live-match-collection.css. */
  var mobilePanelMQ = window.matchMedia('(max-width: 1024px)');
  document.addEventListener('click', function (e) {
    if (!mobilePanelMQ.matches) return;
    var btn = e.target.closest && e.target.closest('.coll-bs-filter-btn');
    if (!btn) return;
    var toggle = document.querySelector('.boost-sd__filter-product-list .boost-sd__filter-tree-toggle-button');
    if (!toggle || !document.getElementById('boost-sd_filter-tree-mobile')) return; // fall back to the theme drawer
    e.preventDefault();
    e.stopPropagation(); // global.js would open the (empty) left-column drawer
    document.body.classList.remove('filter-opened');
    toggle.click();
  }, true);

  /* ------------- 5. "Clear all" in the mobile / tablet panel (Robin 21 Oct) -------------
     Boost's mobile panel has no Clear all; a button is added next to "Show result" and shown
     while anything is selected. It deselects the values one by one so Boost keeps its state. */
  var CLEAR_TXT = { en: 'Clear all', de: 'Alle löschen', fr: 'Tout effacer', it: 'Cancella tutto', es: 'Borrar todo', ja: 'すべてクリア', ko: '모두 지우기', zh: '清除全部' };
  function clearLabel() {
    var l = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    return CLEAR_TXT[l] || CLEAR_TXT.en;
  }
  function mobileClearBtn() {
    var tree = document.getElementById('boost-sd_filter-tree-mobile');
    var foot = tree && tree.querySelector('.boost-sd__filter-tree-vertical-show-result');
    if (!foot) return;
    var btn = foot.querySelector('.lmc-clear-all');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lmc-clear-all';
      btn.textContent = clearLabel();
      foot.appendChild(btn);
    }
    var has = !!tree.querySelector(SELECTED);
    if (foot.classList.contains('lmc-has-clear') !== has) foot.classList.toggle('lmc-has-clear', has);
  }
  function clearAllMobile(guard) {
    guard = guard || 0;
    if (guard > 80) return;
    var tree = document.getElementById('boost-sd_filter-tree-mobile');
    var sel = tree && tree.querySelector(SELECTED);
    if (!sel) return;
    sel.click();
    setTimeout(function () { clearAllMobile(guard + 1); }, 200);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.lmc-clear-all');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    clearAllMobile(0);
  }, true);
  new MutationObserver(mobileClearBtn).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-checked'] });
  mobileClearBtn();
})();
